<template>
<div>
    <el-button type="primary" v-on:click="toAddQuestionType">新增等级</el-button>
    <el-table :data="questionTypes" style="width: 100%;margin-top: 50px;">
        <el-table-column prop="name" label="题型类型" width="180">
        </el-table-column>
        <el-table-column prop="description" label="说明" width="680">
        </el-table-column>
		<el-table-column prop="series" label="排序" width="80">
		</el-table-column>
        <el-table-column label="操作">
            <template slot-scope="scope">
                <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
        </el-table-column>
    </el-table>
    <div class="block" style="float: right;margin:30px;">
        <el-pagination :page-size="pageSize" @current-change="handleCurrentChange" layout="prev, pager, next" :total="counts">
        </el-pagination>
    </div>
</div>
</template>

<script>
import AV from "leancloud-storage";
import QuestionType from "../../model/questionType";
export default {
    data() {
        return {
            pageSize: 5,

            questionTypes: []
        };
    },
    created() {

        this.fetchData();
    },

    methods: {

        handleEdit(index, row) {

            this.$router.push({
                path: "/questionType/add",
                query: {
                    id: row.id
                }
            });

        },

        handleDelete(index, row) {
            AV.User.current().fetch({
                keys: 'role'
            }).then(r => {
               if (r.get('role')=='1999') {

                    this.$confirm("此操作将永久删除题型类型, 是否继续?", "提示", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "warning"
                        }).then(() => {
                            this.$message({
                                type: "success",
                                message: "删除成功!"
                            });
                            row.destroy().then(() => {
                                this.questionTypes.splice(index, 1);
                            });
                        })
                        .catch(() => {

                        });
                } else {
                    this.$message({
                        type: 'warning',
                        message: '没有权限!'
                    })
                }
            })

        },
        handleCurrentChange(page) {
            this.questionCurrentPage = page;
            this.fetchData();

        },
        fetchData() {
            new AV.Query(QuestionType).count().then(c => {
                this.counts = c;
            })
		 
            new AV.Query(QuestionType)
			   .ascending('series')
                .limit(this.pageSize).skip((this.questionCurrentPage - 1) * this.pageSize)
                .find()
                .then(questionTypes => {

                    this.questionTypes = questionTypes;
                })
                .catch(alert);
        },
        toAddQuestionType: function () {
            this.$router.push({
                path: "/questionType/add"
            });
        }
    }
};
</script>
